import * as assets from "../../../assets"

// Google Maps listing for the JaaGa head office, the Orbit by Auro Realty
// tower (Plot 30/C, Raidurg) that the office sits on the 16th floor of.
// Opened (new tab) from every place the office location/address is shown,
// Contact page + site Footer. Opens in SATELLITE view zoomed onto the tower
// (`233m/data=...!1e3`).
export const JAAGA_MAPS_URL =
   "https://www.google.com/maps/place/Orbit+by+Auro+Realty,+Hyderabad/@17.4348823,78.3762693,233m/data=!3m1!1e3!4m6!3m5!1s0x3bcb93cfd19ae321:0x20f3cd74ba70af5d!8m2!3d17.4346446!4d78.3767656!16s%2Fg%2F11h0h_4dlr"

const faq_arr = [
   {
      imgSrc: assets.Heart,
      question: "Is there a free trial is available?",
      answer: "Yes, you can try us with free credits given. Our friendly team can help you where ever needed."
   },
   {
      imgSrc: assets.Switch,
      question: "Can I change my plan later?",
      answer: "Of course. Our pricing scales with your credits. Chat to our friendly team to find a solution that works for you.",

   },
   {
      imgSrc: assets.Cancel,
      question: "What is your cancellation policy?",
      answer: "We understand that things change. You can cancel your plan at any time and we will refund you the difference already used.",

   },
   {
      imgSrc: assets.Billing,
      question: "Can other info be added to an invoice?",
      answer: "At the moment, the only way to add additional information to invoices is to add the information to the profile.",

   },
   {
      imgSrc: assets.FileFaq,
      question: "How does billing work?",
      answer: "Plans are per request, not per account. You can add more credits to get more advantages.",

   },
   {
      imgSrc: assets.MailFaq,
      question: "How do I change my account email?",
      answer: "You can change the email address associated with your account by going to profile.",
   }

]

const contactServices = [
   {
      imgSrc: assets.gif04,
      title: "Add / Manage Property"
   },
   {
      imgSrc: assets.gif01,
      title: "Document Services"
   },
   {
      imgSrc: assets.gif02,
      title: "Legal Services"
   },
   {
      imgSrc: assets.gif03,
      title: "Monitoring Services"
   },

]

const aboutUsmenuItems = [
   {
      id: "who-we-are",
      name: "Who we are",
   },
   {
      id: "what-we-do",
      name: "What we do",
   },
   {
      id: "our-values",
      name: "Our values",
   },
   {
      id: "key-people",
      name: "Key people",
   },
   {
      id: "media-coverage",
      name: "Media coverage",
   },
]

const keyPeoples = [
   {
      id: "1",
      name: "Y.J.Rao. (YJR)",
      position: "Founder, Managing Director - Global Operations.",
      linkendInUrl: "",
      twitterUrl: "",
      about: [
         "He is Citizen of the U.S.A and Overseas Citizen of India.",
         "He has about 25 years of experience as an enterprenuer, founded successful tech companies in the U.S and different ventures in India.",
         "By having vast knowlege about the past, present and future of the real estate industry, founded JaaGa to help anyone to “Find - Save - Manage property from anywhere”",
         "He directs JaaGa, its workforce and service partners to serve clients with complete privacy, transparency and curtesey at all times. He is particular to address the needs of property owners who face challenges to manage their properties remotely and in particular to the needs of Non Resident Indians across the globe."
      ]
   },
   {
      id: "2",
      name: "C.C.S.Reddy",
      position: "Managing Director - Indian Operations.",
      linkendInUrl: "https://www.linkedin.com/in/cyberchandu/",
      twitterUrl: "",
      about: [
         "Chandra Sekara Reddy is the Chief Executive Officer at CSCC LABS and acts as an Managing Director at JaaGa Real Estate Services.",
         "He holds an Bachelor’s Degree from the Birla Institute of Technology and Science, Pilani (BITS Pilani).",
         "Chandra Sekara Reddy is the Founder & CEO of CSCC LABS, a cybersecurity company based in Hyderabad, Telangana, India. He has been actively involved in building a SaaS solution with a custom Agent/Sensor to assist Incident Analysis (IA), Incident Response (IR), and Attack simulation for organizations and consultants. The solution aims to save time and costs significantly, providing non-tampered results and achieving 100% coverage with no human intervention.",
         "He founded three technology & Cyber Security companies and has been guiding start-ups and young management graduates."

      ]
   },
   {
      id: "3",
      name: "L.Srinath. R",
      position: "Advisor to the board.",
      linkendInUrl: "",
      twitterUrl: "",
      about: [
         "Srinath Reddy is the Managing Director of Raminfo and acts as an advisor to the board at JaaGa Real Estate Services.",
         "He holds an MBA from the Indian School of Business (ISB).",
         "He holds an MBA from the Indian School of Business (ISB). He is a highly accomplished technology professional with vast experience in various strategic and operational roles of enterprise building, mergers & acquisitions, global organizational restructuring and transformation/change management and business process re-engineering,.",
         "He has about 25 years of experience with a combination of working with big consulting companies and various midsize companies. He worked with McKinsey & Company, a premier global management consulting company for 10+ years in the USA.",
         "He co-founded three technology companies and has been guiding start-ups and young management graduates. He is associated with Sri VidyaArogya charitable trust, a charitable organization to fund education and health initiatives."
      ]
   }
]


const advisors = [
   {
      id: "1",
      name: "J.V.Ramudu",
      position: "Advisor to the board",
      profission: "Ex.DGP, Government of A.P.Ravi",
      twitterUrl: "",
      linkendInUrl: "https://www.linkedin.com/in/j-ramudu-155337213/"
   },
   {
      id: "2",
      name: "Prasad. P",
      position: "Advisor to the board",
      profission: "Tempus Law Associates",
      twitterUrl: "",
      linkendInUrl: "https://www.linkedin.com/in/raviprasad-p-616ab710/"
   },
   {
      id: "3",
      name: "Pratap. J",
      position: "Advisor to the board",
      profission: "Ex.DGP, Government of A.P.Ravi",
      twitterUrl: "",
      linkendInUrl: ""
   }
]

const mediaCoverage = [
   {
      id: "1",
      imgSrc: assets.News1,
      linkUrl: 'https://www.moneyworks4me.com/company/news/index/id/596035',
      content: "Raminfo to make upto 10% investment in Jaaga Real Estate Services",
      date: "Sep 07 2023"
   },
   {
      id: "2",
      imgSrc: assets.News2,
      linkUrl: "https://www.moomoo.com/news/flash/16497095?level=1&data_ticket=1694751630402488",
      content: "Raminfo to make upto 10% investment in Jaaga Real Estate Services",
      date: "Sep 07 2023"
   },
   {
      id: "2",
      imgSrc: assets.News3,
      linkUrl: "https://www.marketscreener.com/quote/stock/RAMINFO-LIMITED-20704723/news/Raminfo-to-Acquire-10-Stake-in-Jaaga-Real-Estate-Services-44799199/",
      content: "Latest news about Raminfo Limited",
      date: "Dec 04 2023"
   }
]

const listingImgData = [
   { key: "propertyArea", image: assets.Area },
   { key: "GROSS_AREA", image: assets.grossarea },
   { key: "CARPET_AREA", image: assets?.carpetarea },
   { key: "UNDIVIDED_AREA", image: assets.undividedarea},
   { key: "SELL_PRICE_PER", image: "" },
   { key: "TOTAL_SELL_PRICE", image: "" },
   { key: "MINIMUM_SELL_PRICE", image: "" },
   { key: "DEAL_CLOSURE_TIMEFRAME", image: "" },
   { key: "RENT_PRICE", image: "" },
   { key: "TOTAL_SELL_PRICE", image: "" },
   { key: "MINIMUM_RENT_PRICE", image: "" },
   { key: "MAINTENANCE", image: "" },
   { key: "DEPOSIT", image: "" },
   { key: "PROPERT_AVAILABLE_FROM", image: "" },
   { key: "AGE_OF_PROPERTY", image: "" },
   { key: "PANTRY", image: "" },
   { key: "PERSONAL_WASHROOM", image: "" },
   { key: "COVERED_PARKING", image: "" },
   { key: "OPEN_UNCOVERED_PARKING", image: "" },
   { key: "POWER_BACKUP", image: "" },
   { key: "LIFT_AVAILABILITY", image: "" },
   { key: "VIEW", image: "" },
   { key: "FLOORING", image: "" },
   { key: "FLOOR_NUMBER", image: "" },
   { key: "CEILING_HEIGHT", image: "" },
   { key: "CORNER_SHOP", image: "" },
   { key: "MAINROAD_FACEING", image: "" },
   { key: "TOWN_BLOCK", image: "" },
   { key: "TOTAL_FLOORS_COUNT", image: assets.floors },
   { key: "UNIT_NUMBER", image: "" },


   { key: "BALCONY", image: assets.balcony },
   ];







export {
   faq_arr,
   contactServices,
   aboutUsmenuItems,
   keyPeoples,
   advisors,
   mediaCoverage,
   listingImgData,


}